// extracted by mini-css-extract-plugin
export default {"advertDetailRemovalInformation_link":"c-a_el"};